import { DateFormater } from "functions/dateTimeFormat";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const DefaultPopulationComponent = () => {
  var [date, setDate] = useState(new Date());

  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });
  const locale = useSelector(({ theme }) => theme.locale);

  var weekday = [
    "الاحد",
    "الاثنين",
    "الثلاثاء",
    "الاربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ];
  var showTime = "";
  var x = "ص";
  var hours = new Date().getHours();
  if (hours > 12) {
    hours -= 12;
    x = "م";
  }
  if (hours < 10) showTime += "0";
  showTime = showTime + hours + ":";
  var mins = new Date().getMinutes();
  if (mins < 10) showTime += "0";
  showTime += mins + ":";
  var sec = new Date().getSeconds();
  if (sec < 10) showTime += "0";
  showTime += sec;
  var time = "الساعة " + showTime + x + "  حسب توقيت القاهرة";
  var now = "الان";
  if (locale === "en") {
    weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    if (x === "م") x = "pm";
    else x = "am";
    time = "The time is " + showTime + " " + x + " according to Cairo time";
    now = "now";
  }
  return (
    <div className="row pb-3 text-center" style={{ width: "1000px" }}>
      <h6>
        {weekday[new Date().getDay()]}
        ,&nbsp;
        <DateFormater value={Date.now()} />
      </h6>
      <h6>{time}</h6>
    </div>
  );
};

export default DefaultPopulationComponent;
